// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__jcKoq","inner":"Form_inner__2l0AL","range":"Form_range__1EtY8","name":"Form_name__PrF4z","actions":"Form_actions__2VvzG"};